import './conversation_attribute_view.js.coffee';# Added by Script 
class Customer.HierarchicalTagsAttributeView extends Customer.ConversationAttributeView
  template: JST['backbone/templates/customer/custom_attributes/hierarchical_tags']

  initialize: ({model}) ->
    super({model: model})
    @initialValues = @getValue()

  render: ->
    super()
    @_renderSelect()
    @_renderErrors()
    @

  _renderSelect: =>
    @tags ||= new AccountSettings.ConversationAttributes.HierarchicalTagCollection(
      @model.get('definition').get('hierarchical_tags').tags
    )
    @options ||= @tags.toJSON()
    @placeholders ||= @_placeholders()

    @selectViews = @_getSelected().map((selectedOption, index) =>
      hierarchicalSelectView = new App.HierarchicalSelectView({
        width: '100%'
        selectedOptions: if _.isArray(selectedOption) then selectedOption else @tags.codePathTo(selectedOption),
        @options
        @placeholders
        valueProperty: 'code'
        descriptionProperty: 'description'
        childrenProperty: 'children'
        allowEmptyProperty: 'choosable'
        allowEmpty: true
        renderCross: true
      })

      @listenTo(
        hierarchicalSelectView,
        'change',
        (newSelection) =>
          @_onChange(newSelection, index)
          @trigger('conversation:attributes:edit')
      )
      @$el.find('#hierarchical-select').html(
        hierarchicalSelectView.render().el
      )
      hierarchicalSelectView
    )

  validValue: ->
    errors = @model.getErrors()
    _.isEmpty(errors)

  _renderErrors: =>
    errors = @model.getErrors()
    @_renderErrorMessages(errors)
    @_renderSelectRedBorder() if @model.error || (errors && errors.length)

  _renderErrorMessages: (errors) =>
    @$el.find('#errors').html(
      errors.map(@_errorTemplate)
    )

  _renderSelectRedBorder: (errors) =>
    @$el.find('.hierarchical-select #current-level:last').addClass('error')

  _getSelected: =>
    value = @getValue()
    return value if _.isArray(value) && value.length
    return [[]]

  _onChange: (selectedOptions, index) =>
    oldValue = @getValue() || []
    newValue = [oldValue...]
    last_value = selectedOptions.reverse()[0]
    if last_value
      newValue.splice(index, 1, last_value)
    else
      newValue = []
    @setValue(newValue)
    @_renderSelect()
    @_renderErrors()

  _placeholders: =>
    hierarchicalTags = @model.get('definition').get('hierarchical_tags')
    config = new AccountSettings.ConversationAttributes.HierarchicalTagConfig(hierarchicalTags)
    metadata = config.get('metadata').getLevels().map(({description}) -> description)

  getAdded: ->
    currentValueLeaf = _.last @getValue()
    return null if _.isEmpty currentValueLeaf
    initialValueLeaf = _.last @initialValues
    return null if currentValueLeaf == initialValueLeaf

    definition_code: @getDefinitionCode(),
    values: [[currentValueLeaf]]

  getDeleted: ->
    initialValueLeaf = _.last @initialValues
    return null if _.isEmpty initialValueLeaf
    currentValueLeaf = _.last @getValue()
    return null if currentValueLeaf == initialValueLeaf

    definition_code: @getDefinitionCode(),
    values: [[initialValueLeaf]]

  getValue: ->
    value = @model.getValue()
    if _.isEmpty(value) then [[]] else value[0].value[0]

  setValue: (newValue) ->
    @model.set('value', [{value: [newValue]}])
